import { TrolleySize } from './TrolleySize';

export default TrolleySize;
